import { Stack, styled } from "@mui/material";
import { IStyledStackProps } from "./types";

const StyledStack = styled(Stack)<IStyledStackProps>(({theme})=>({

}))

export {StyledStack}